<template>
  <div
v-loading="loading"
class="media-files">
    <div
      v-if="!form[field.key] || !form[field.key].length"
      class="text-primary"
    >
      Chưa có dữ liệu
    </div>
    <el-row
v-else
class="list-files mb-l"
:gutter="16">
      <el-col
        v-for="(file, index) in sortedFiles"
        :key="index"
        :lg="4"
        :md="6"
        :sm="8"
        :span="12"
        class="mt-m"
        style="min-width: 120px;"
      >
        <el-button
          v-if="!disabled"
          type="danger"
          class="remove-file"
          circle
          size="mini"
          @click="handleRemove(file)"
        >
          <i class="el-icon-close" />
        </el-button>
        <el-button
          v-if="type !== fileType.AUDIO"
          type="primary"
          class="download-file"
          size="mini"
          plain
          icon="el-icon-download"
          :loading="file.downing"
          @click="handleDownload(file)"
        />
        <FileCard
          :key="file.id"
          :file="file"
          :type="type"
          :show-name="true"
        />
      </el-col>
    </el-row>
    <el-row v-if="!disabled">
      <el-button
        icon="el-icon-plus"
        type="primary"
        plain
        @click="handleAdd"
      >
        Thêm mới
      </el-button>
      <el-button
        v-if="form[field.key] && form[field.key].length && isSort"
        icon="el-icon-sort"
        @click="handleSort"
      >
        Sắp xếp
      </el-button>
    </el-row>
    <SelectFilesPopup
      v-if="selectVisible"
      :visible="selectVisible"
      :type="type"
      :current-files="form[field.key] || []"
      @close="() => (selectVisible = false)"
      @selected="handleSelected"
    />
    <SortFilesPopup
      v-if="isSort"
      :visible="sortVisible"
      :files="sortedFiles"
      :type="type"
      @close="() => (sortVisible = false)"
      @sorted="handleSorted"
    />
  </div>
</template>

<script>
import constants from "@/config/constants";
import FileCard from "./FileCard.vue";
import SelectFilesPopup from "../popups/SelectFiles.vue";
import SortFilesPopup from "../popups/SortFiles.vue";

import fileServices from "@/services/file";
import organizationServices from "@/services/organization"
import { downloadFile } from "@/utils/common";

export default {
  name: "Files",
  components: {
    FileCard,
    SelectFilesPopup,
    SortFilesPopup,
  },
  props: {
    form: Object,
    field: Object,
    disabled: Boolean,
  },
  data() {
    return {
      fileType: constants.FILE_TYPE,
      selectVisible: false,
      sortVisible: false,
      loading: false,
      fileList: [],
      downloadFiles: [],
      organizationId: organizationServices.getCurrentOrg()?.id
    };
  },
  computed: {
    fileIds() {
      return (this.form[this.field.key] || []).map((f) => f.id);
    },
    sortedFiles() {
      return (this.form[this.field.key] || [])
        .map((f) => {
          const fileInfo = this.fileList.find((file) => file.id === f.id);
          return fileInfo
            ? {
                ...f,
                ...fileInfo,
                downing: this.downloadFiles.includes(f.id),
              }
            : null;
        })
        .filter(Boolean);
    },
    type() {
      switch (this.field.type) {
        case constants.FIELD_TYPE.FILE_IMAGES:
          return this.fileType.IMAGE;
        case constants.FIELD_TYPE.FILE_VIDEOS:
          return this.fileType.VIDEO;
        case constants.FIELD_TYPE.FILE_AUDIOS:
          return this.fileType.AUDIO;
        default:
          return this.fileType.OTHER;
      }
    },
    params() {
      const _params = {
        offset: 0,
        limit: this.fileIds.length,
        locale: "vi",
      };
      _params.filters = {
        id: { $in: this.fileIds },
        organization_id: this.organizationId,
      };
      return _params;
    },
    isSort() {
      return ![this.fileType.AUDIO, this.fileType.OTHER].includes(this.type);
    },
  },
  beforeMount() {
    this.listData();
  },
  methods: {
    listData() {
      if (this.fileIds.length > 0) {
        this.loading = true;
        fileServices
          .list(this.params)
          .then((response) => {
            this.fileList = response.items.map((item) => ({
              id: item.id,
              name: item.extra.name,
              url: item.url,
              extra: item.extra,
            }));
            this.loading = false;
          })
          .catch(() => {
            this.data = [];
            this.loading = false;
          });
      }
    },
    handleAdd() {
      this.selectVisible = true;
    },

    handleSort() {
      this.sortVisible = true;
    },

    handleRemove(file) {
      this.form[this.field.key] = this.form[this.field.key].filter(
        (f) => f.id !== file.id
      );
    },

    async handleDownload(file) {
      if (this.downloadFiles.includes(file.id)) {
        return;
      }
      this.downloadFiles.push(file.id);
      await downloadFile(file.url, file.name);
      setTimeout(() => {
        this.$notify.success({
          title: "Thông báo!",
          message: "Tải file thành công!",
        });
        this.downloadFiles = this.downloadFiles.filter((f) => f !== file.id);
      }, 2000);
    },

    handleSelected(files) {
      this.form[this.field.key] = [
        ...this.form[this.field.key],
        ...files.map((f) => ({
          id: f.id,
          is_avatar: false,
        })),
      ];
      this.fileList = [...this.fileList, ...files];
    },

    handleSorted(files) {
      this.form[this.field.key] = files.map((f) => ({
        id: f.id,
        is_avatar: f.is_avatar,
      }));
    },
  },
};
</script>

<style lang="scss">
.media-files {
  .list-files {
    .el-col {
      position: relative;
      .remove-file {
        position: absolute;
        right: 0%;
        top: -5%;
        z-index: 1;
      }
      .download-file {
        position: absolute;
        right: 10px;
        top: 90px;
        z-index: 1;
      }
      .file-card-item {
        .file-image {
          width: 100%;
          height: 120px;
          border-radius: 4px;
          object-fit: cover;
          cursor: pointer;
          border: 1px solid #409eff;
        }
        .file-video {
          width: 100%;
          height: 120px;
          border-radius: 4px;
          cursor: pointer;
          border: 1px solid #409eff;
        }
        .file-audio {
          width: 100% !important;
        }
        .file-other {
          width: 100%;
          height: 120px;
          border-radius: 4px;
          object-fit: cover;
          border: 1px solid #409eff;
        }
      }
    }
  }
}
</style>
